export const addFormValidator = (formId, constraints) => {
  let rule = constraints.find((item) => item.field === formId);
  let objname = rule.field;
  let tmpObj = {};
  tmpObj[objname] = {};

  if (rule.isRequired) {
    tmpObj[objname].required = {
      value: rule.isRequired.value,
      message: rule.isRequired.msg,
    };
  }
  if (rule.maxLength) {
    tmpObj[objname].maxLength = {
      value: rule.maxLength.value,
      message: rule.maxLength.msg,
    };
  }

  if (rule.max) {
    tmpObj[objname].max = {
      value: rule.max.value,
      message: rule.max.msg,
    };
  }
  if (rule.minLength) {
    tmpObj[objname].minLength = {
      value: rule.minLength.value,
      message: rule.minLength.msg,
    };
  }
  if (rule.min) {
    tmpObj[objname].min = {
      value: rule.min.value,
      message: rule.min.msg,
    };
  }
  if (rule.pattern) {
    tmpObj[objname].pattern = {
      value: new RegExp(rule.pattern.value, "u"),
      message: rule.pattern.msg,
    };
  }

  return tmpObj;
};
